import { render, staticRenderFns } from "./evaluacion-preguntas.vue?vue&type=template&id=2d954b07&"
import script from "./evaluacion-preguntas.vue?vue&type=script&lang=js&"
export * from "./evaluacion-preguntas.vue?vue&type=script&lang=js&"
import style0 from "./evaluacion-preguntas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports